<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="type == 'merge'">MERGE STREAM</h1>
        <h1 v-else>DOWNLOAD STREAM</h1>
      </div>
      <div class="form-modal-body">
        <draggable class="list-group" v-model="sessionList" v-bind="dragOptions" @start="isDragging = true"
          @end="isDragging = false">

          <div class="session-item list-group-item" v-for="(item, index) in sessionList" :key="index">
            <div class="session-item-left-panel">
              <div class="session-options">
                <input type="checkbox" v-model="item.checked" name="" id="">
              </div>
              <div class="session-brand">
                <img :src="stream_cdn_server_url + '/watch.rw/' + item.sessionId + '/preview.webp'"
                  class="session-cover">
                <div class="session-brand-overlay">
                  <button @click="playVideo(item)" class="btn-play">
                    <img src="@/assets/images/icons/play.svg">
                  </button>
                  <div class="video-time" v-if="item.status == 'completed' || item.status == 'uploaded'">
                    {{ toHHMMSS(parseFloat(item.totalRecordTime)) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="session-drag-icon">
              <img src="@/assets/images/icons/drag.svg" width="30">
            </div>
          </div>

        </draggable>
      </div>
      <div class="form-modal-footer">
        <b-button v-if="type == 'merge'" :loading="submit_loading" @click="mergeStream"
          type="is-primary">MERGE</b-button>
        <b-button v-else :loading="submit_loading" @click="downloadStream" type="is-primary">DOWNLOAD</b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>

    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" v-if="selected_video_url" :width="800">
      <div style="height: 500px">
        <ClapprPlayer :src="selected_video_url" :type="'hls'"></ClapprPlayer>
      </div>
    </b-modal>
  </b-modal>
</template>
<script>
import { MEDIA_SERVER_BASE_URL, STREAMING_CDN_SERVER_BASE_URL, LIVE_STREAMING_CDN_SERVER_BASE_URL } from "@/store/variables.js";
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
  },
  props: {
    stream: {
      type: Object,
      default: null,
    },
    sessions: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "merge"
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 1,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  data: () => ({
    media_server_url: MEDIA_SERVER_BASE_URL,
    stream_cdn_server_url: STREAMING_CDN_SERVER_BASE_URL,
    selected_video_url: null,
    show_player: false,
    selected_date: new Date(),
    isModalActive: true,
    submit_loading: false,
    form: {
      streamId: null,
      sessions: []
    },
    sessionList: [],
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.stream) {
      vm.form.streamId = vm.stream.id;
      vm.sessionList = vm.sessions.map((session) => {
        session.checked = true;
        return session;
      });
    }
  },
  methods: {
    playVideo(item) {
      let vm = this;
      vm.selected_video_url = STREAMING_CDN_SERVER_BASE_URL + "/" + item.hlsPath;
      vm.show_player = true;
    },
    mergeStream() {
      let vm = this;
      vm.form.streamId = vm.stream.id;
      vm.form.sessions = vm.sessionList.filter((session) => session.checked);
      if (vm.form.sessions.length < 2) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "OOPS!!!",
          text: "Please select at least 2 sessions to merge.",
        });
        return;
      }
      vm.$confirm({
        title: "Confirm",
        message: `This action will merge the selected sessions with specified order. Do you want to proceed? This action will take some time.`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.submit_loading = true;
            vm.$store
              .dispatch("STREAMING_MERGE_STREAM", vm.form)
              .then((response) => {
                vm.submit_loading = false;
                vm.$emit("saved", response.data.return);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.submit_loading = false;
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    downloadStream() {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `This action will download the selected sessions with specified order. Do you want to proceed? This action will take some time in order to get your link.`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.submit_loading = true;
            vm.form.streamId = vm.stream.id;
            vm.form.sessions = vm.sessionList.filter((session) => session.checked);
            vm.$store
              .dispatch("STREAMING_DOWNLOAD_STREAM", vm.form)
              .then((response) => {
                vm.submit_loading = false;
                vm.$emit("saved", response.data.return);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.submit_loading = false;
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });

    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    }
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 400px;
    padding-bottom: 30px;

    .session-item {
      display: flex;
      align-items: center;
      border: 1px solid #ddd;
      margin-bottom: 10px;
      padding: 8px;
      border-radius: 5px;

      .session-item-left-panel {
        display: flex;
        align-items: center;
        width: calc(100% - 80px);
        height: 50px;
        margin-right: 10px;

        .session-options {
          margin-right: 10px;
        }

        .session-brand {
          position: relative;
          height: 100%;

          .session-cover {
            width: 180px;
            height: 100%;
            object-fit: cover;
          }

          .session-brand-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.5);
            transition: all 0.3s ease;

            .btn-play {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: all 0.3s ease;

              &:hover {
                background: #ddd;
              }
            }

            .video-time {
              color: #fff;
              font-size: 12px;
              margin-left: 10px;
              position: absolute;
              bottom: 5px;
              right: 5px;

            }

            .session-dropdown-options {
              position: absolute;
              top: 5px;
              right: 5px;
              color: #fff;
            }
          }
        }
      }

      .session-drag-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 100%;
        cursor: move;
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>


<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
